import { Grid } from '@material-ui/core';
import React, { FC } from 'react';
import { AlternateRowContainer } from 'src/views/product/component/AlternateRowContainer';
import { AuditListingProps } from 'src/types';
import { ProductNameAndSerialNos } from './ProductNameAndSerialNos';
import { AuditAndAvailableCounts } from './AuditAndAvailableCounts';
import { ProductLabelAndStatus } from './ProductLabelAndStatus';

interface Props {
  key: number;
  ind: number;
  canSeeCount?: boolean;
  handleAuditCountChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    product_id?: number
  ) => void;
}

export const MobileAuditListingRow: FC<Props & AuditListingProps> = ({
  key,
  ind,
  id,
  auditedCount = 0,
  availableListingCount = 0,
  productName = '',
  isSerialized = false,
  scannedSerialNos = [],
  canSeeCount = false,

  handleAuditCountChange
}) => {
  return (
    <Grid item xs={12} key={key}>
      <AlternateRowContainer index={ind}>
        <Grid item xs={12} container style={{ padding: '1em', gap: '.5em' }}>
          <ProductLabelAndStatus
            auditedCount={auditedCount}
            availableListingCount={availableListingCount}
          />

          <ProductNameAndSerialNos
            isSerialized={isSerialized}
            id={id}
            productName={productName}
            scannedSerialNos={scannedSerialNos}
          />

          <AuditAndAvailableCounts
            id={id}
            canSeeCount={canSeeCount}
            auditedCount={auditedCount}
            isSerialized={isSerialized}
            availableListingCount={availableListingCount}
            handleAuditCountChange={handleAuditCountChange}
          />
        </Grid>
      </AlternateRowContainer>
    </Grid>
  );
};
